const INVENTORY_IMAGE = 'https://readdy.ai/api/search-image?query=large%20outdoor%20used%20tire%20inventory%20lot%20with%20hundreds%20of%20tires%20stacked%20in%20rows%20along%20a%20fence%20at%20a%20tire%20dealer%20shop%2C%20various%20sizes%20of%20car%20and%20truck%20tires%20organized%20in%20piles%2C%20industrial%20outdoor%20storage%20area%2C%20overcast%20sky%2C%20realistic%20automotive%20business%2C%20dark%20tones%2C%20tire%20shop%20exterior%20yard%20with%20massive%20stock%2C%20ground%20level%20view%20showing%20depth%20of%20inventory%2C%20commercial%20tire%20dealer&width=1200&height=750&seq=101&orientation=landscape';

export default function InventorySection() {
  return (
    <section
      id="inventory"
      className="relative overflow-hidden"
      style={{ backgroundColor: '#1a1a1a' }}
      aria-label="在庫・サービス紹介"
    >
      <div className="flex flex-col lg:flex-row min-h-[500px]">
        {/* Left: Text content */}
        <div
          className="flex-1 flex flex-col justify-center px-8 md:px-16 py-20 md:py-28"
          style={{ backgroundColor: '#1a1a1a' }}
        >
          <p
            className="text-xs font-bold tracking-widest uppercase mb-4"
            style={{ color: '#f5a623', fontFamily: '"Oswald", sans-serif', letterSpacing: '4px' }}
          >
            Inventory &amp; Service
          </p>
          <h2
            className="text-3xl md:text-5xl font-black text-white mb-6 leading-tight"
            style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
          >
            幅広いサイズを<br />
            <span style={{ color: '#f5a623' }}>取り揃えております</span>
          </h2>
          <div className="w-12 h-1 mb-8" style={{ backgroundColor: '#f5a623' }} />
          <p
            className="text-base md:text-lg leading-loose mb-8 max-w-md"
            style={{ color: 'rgba(255,255,255,0.8)', fontFamily: '"Noto Sans JP", sans-serif', lineHeight: '2.0' }}
          >
            軽自動車からトラックまで幅広いサイズを取り揃えております。<br />
            サイズ・予算に合わせてご提案致しますので、お気軽にご相談ください。
          </p>

          {/* Size tags */}
          <div className="flex flex-wrap gap-2">
            {['軽自動車', 'コンパクトカー', 'セダン・ミニバン', 'SUV・4WD', '軽トラック', 'トラック', 'ハイエース', '日産 キャラバン'].map((size) => (
              <span
                key={size}
                className="px-3 py-1 text-xs font-medium"
                style={{
                  border: '1px solid rgba(245,166,35,0.4)',
                  color: 'rgba(255,255,255,0.7)',
                  fontFamily: '"Noto Sans JP", sans-serif',
                }}
              >
                {size}
              </span>
            ))}
          </div>
        </div>

        {/* Right: Image */}
        <div className="lg:w-[55%] relative min-h-[350px] lg:min-h-[500px]">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${INVENTORY_IMAGE})` }}
            role="img"
            aria-label="大量の中古タイヤ在庫"
          />
          {/* Gradient overlay on left side for blend */}
          <div
            className="absolute inset-0"
            style={{
              background: 'linear-gradient(to right, rgba(26,26,26,1) 0%, rgba(26,26,26,0.1) 40%, rgba(26,26,26,0.2) 100%)',
            }}
          />
          {/* Dark overlay for text readability */}
          <div
            className="absolute inset-0"
            style={{ backgroundColor: 'rgba(26,26,26,0.2)' }}
          />

          {/* Stock badge */}
          <div
            className="absolute bottom-8 right-8 px-6 py-4 text-center"
            style={{ backgroundColor: '#f5a623' }}
          >
            <div
              className="text-3xl font-black"
              style={{ color: '#1a1a1a', fontFamily: '"Oswald", sans-serif' }}
            >
              500<span className="text-xl">+</span>
            </div>
            <div
              className="text-xs font-bold mt-1"
              style={{ color: '#1a1a1a', fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              常時在庫本数
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}